import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Col, Container, Row } from 'react-bootstrap'
import { LoadingComponent } from 'recupero-comunes'
import FiltrosDashboard from './filtros-dashboard'
import BloqueVolumen from './bloque-volumen'
import BloqueResponsables from './bloque-responsables'
import BloqueFinanciero from './bloque-financiero'
import BloqueAlertas from './bloque-alertas'
import { SeccionTitulo } from './metric-card'
import Mensajes from '../mensajes'
import { periodoPorDefecto } from '../../common/formato-dashboard'
import { obtenerMetricasRecupero } from '../../store/actions/dashboard-recupero-action'

const fechaActualizacion = () =>
    new Date().toLocaleDateString('es-CO', { day: 'numeric', month: 'short', year: 'numeric' })

const DashboardRecupero = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [actualizado, setActualizado] = useState(null)
    const { metricas } = useSelector((state) => state.dashboardRecuperoReducer)

    const cargarMetricas = (periodo) => {
        setLoading(true)
        setError(null)
        dispatch(obtenerMetricasRecupero(periodo))
            .then(() => setActualizado(fechaActualizacion()))
            .catch((err) => setError({ code: -1, message: err?.message || 'No fue posible cargar el dashboard.' }))
            .then(() => setLoading(false))
    }

    useEffect(() => {
        cargarMetricas(periodoPorDefecto())
    }, [dispatch])

    return (
        <div>
            <LoadingComponent show={loading} />
            <div className='position-fixed top-0 end-0 p-3' style={{ zIndex: 3100 }}>
                <Mensajes showToast={!!error} handleCloseToast={() => setError(null)} delay={5000} responseData={error} />
            </div>
            <div className='text-center text-white fw-bold py-2' style={{ backgroundColor: '#4F517A' }}>
                Dashboard — Recupero Directo Colombia
            </div>
            <div className='d-flex justify-content-end px-3 py-2 small text-muted border-bottom bg-white'>
                <span>{actualizado ? `Actualizado: ${actualizado} | ` : ''}COP</span>
            </div>
            <Container fluid className='px-3 py-3'>
                <FiltrosDashboard onAplicar={cargarMetricas} disabled={loading} />

                <SeccionTitulo>A — Volumen de casos</SeccionTitulo>
                <BloqueVolumen data={metricas?.bloque_volumen} />

                <SeccionTitulo>B — Gestión por responsable</SeccionTitulo>
                <div className='border rounded bg-white p-3'>
                    <BloqueResponsables data={metricas?.bloque_responsables} />
                </div>

                <Row className='mt-0'>
                    <Col lg={7}>
                        <SeccionTitulo>C — Eficiencia financiera</SeccionTitulo>
                        <BloqueFinanciero data={metricas?.bloque_financiero} />
                    </Col>
                    <Col lg={5}>
                        <SeccionTitulo>D — Alertas de antigüedad</SeccionTitulo>
                        <BloqueAlertas data={metricas?.bloque_alertas} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default DashboardRecupero
